<template>
  <Modal ref="modal">
    <div class="row">
      <div class="form-group">
        <label class="col-4">Name</label>
        <input class="form-control col-8" type="text" v-model="salary.name" />
      </div>

      <div class="row">
        <div class="form-group col-4">
          <label class="col-4">Value</label>
          <input class="form-control col-8" type="number" v-model="salary.value" currency />
        </div>

        <div class="form-group col-4">
          <label class="col-4">Hours</label>
          <input class="form-control col-8" type="number" v-model="salary.hours" />
        </div>

        <div class="form-group col-4">
          <label class="col-4">Hours per day</label>
          <input class="form-control col-8" type="number" v-model="salary.hoursPerDay" />
        </div>
      </div>

      <div class="form-group">
        <label class="col-4">Description:</label>
        <textarea class="form-control col-8" v-model="salary.description"></textarea>
      </div>

      <div v-if="salary.months">
        <MonthsCheckbox v-model="salary.months"></MonthsCheckbox>
      </div>

      <div>
        <button type="button" class="btn btn-link" v-on:click="addOvertime">
          <font-awesome-icon icon="plus"/>
        </button>
        <div v-for="overtime in salary.overtimes" v-bind:key="overtime.id">
          <OvertimeEdit v-bind:overtime="overtime"></OvertimeEdit>

          <div class="actions">
            <div class="btn-group" role="group">
              <button type="button" class="btn btn-dark" v-on:click="delOvertime(overtime)">
                <font-awesome-icon icon="trash-alt"/>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <button class="btn btn-dark" v-on:click="$refs.modal.ok()">OK</button>
      <button class="btn btn-dark" v-on:click="$refs.modal.cancel()">Anuluj</button>
    </div>

    <ModalQuestion ref="question"></ModalQuestion>
  </Modal>
</template>

<script>
export default {
  data() {
    return {
      salary: {}
    };
  },
  methods: {
    show(salary) {
      this.salary = this.$tools.copyOf(salary);

      return this.$refs.modal.open().then(() => {
        return this.salary;
      });
    },
    addOvertime() {
      let overtime = this.$piggyBank.data.newOvertime();
      this.salary.overtimes = this.salary.overtimes || [];
      this.salary.overtimes.push(overtime);
      this.$forceUpdate();
    },
    delOvertime(overtime) {
      this.$refs.question
        .ask("Czy usunąć nadgodziny")
        .then(() => {
          let index = this.salary.overtimes.indexOf(overtime);
          this.salary.overtimes.splice(index, 1);
          this.$forceUpdate();
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
</style>